import { jsx as _jsx } from "react/jsx-runtime";
import { Plasmantine, Title, createTheme } from '@components/mantine';
import TitleClasses from './Title.module.css';
/**
 * This theme should only contain overrides that are specific to the docs app.
 */ var docsAppTheme = createTheme({
    fontSmoothing: true,
    components: {
        Title: Title.extend({
            classNames: TitleClasses
        })
    }
});
export var DocsAppTheme = function DocsAppTheme(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Plasmantine, {
        theme: docsAppTheme,
        children: children
    });
};

//# sourceMappingURL=DocsAppTheme.js.map